/* eslint-disable */

import React, { useState, useEffect } from "react";
import AddTopic from "./AddTopic";
import TopicsList from "./TopicsList";
import { FEED, TOPICS } from "../../constants/route-constants";
import { httpGet } from "../../utility/requestHelper";
import { unifiedEnvConfig } from "../../constants/api-endpoint";
import { Button } from "../Shared/FormElements/Button";
import {
  CONSTANTS,
  VERTICAL_OPTIONS,
  VERTICALS,
} from "../../constants/app-constant";
import { UserDropdown } from "../Shared/UserDropdown";
import { useSelector, useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { NoFeedIcon, WidgetBuildingIcon } from "../Icons/icons.component";
import "./topics.sass";
import { setSelectedEntity } from "../../actions/entity-action";
import Loader from "../Shared/Loader";

const { EMPTY_ARRAY } = CONSTANTS;

export default function Topics({
  history,
  setSelectedTab,
  isWidgetPage,
  selectedTopicList,
  setSelectedTopicList,
  selectedVertical,
}) {
  const dispatch = useDispatch();
  const { topicTabId, entityId } = useParams();
  const [showAddTopic, setShowAddTopic] = useState(false);
  const [socialTopicData, setSocialTopicData] = useState({
    pagination: {
      pages: 1,
      data: EMPTY_ARRAY,
      total: 0,
    },
  });
  const [isSocialTopicsLoading, setIsSocialTopicsLoading] = useState(true);

  const selectedClient =
    useSelector(
      (state) => state.clientReducer && state.clientReducer.selectedClient
    ) || {};

  const entityState =
    useSelector((state) => state.entityAndKeyWordsReducer) || {};

  const [limit, setLimit] = useState(1);
  const [editData, setEditData] = useState();
  const [socialTopicList, setSocialTopicList] = useState(EMPTY_ARRAY);
  const [hideShowMore, setHideShowMore] = useState(false);
  const [noTopicsFound, setNoTopicsFound] = useState(false);

  const editWidgetSelectedVertical = selectedVertical && selectedVertical.value;
  const {
    entityDetails: { entityList = [], isLoading, error },
    socialEntityList,
  } = entityState || {};

  const selectedEntity = entityList.filter((el) => el.id === entityId)[0];

  const currentSelectedTopicTab = isWidgetPage
    ? editWidgetSelectedVertical
    : topicTabId;

  useEffect(() => {
    if (!selectedClient.id || showAddTopic) {
      return;
    }
    fetchSocialTopics();
  }, [limit, selectedClient.id, showAddTopic]);

  useEffect(() => {
    if (
      socialTopicData &&
      socialTopicData.pagination &&
      socialTopicData.pagination.total &&
      socialTopicList
    ) {
      setHideShowMore(
        socialTopicData.pagination.total === socialTopicList.length
      );
    }
    checkForData();
  }, [
    socialTopicList && socialTopicList.length,
    entityList && entityList.length,
  ]);

  useEffect(() => {
    if (showAddTopic) {
      setNoTopicsFound(false);
    } else {
      checkForData();
    }
  }, [showAddTopic, currentSelectedTopicTab]);

  useEffect(() => {
    checkForData();
  }, [topicTabId]);

  const checkForData = () => {
    if (isSocial) {
      setNoTopicsFound(socialTopicList && !socialTopicList.length);
    } else {
      if (!isLoading) {
        if (error) {
          setNoTopicsFound(true);
        } else {
          setNoTopicsFound(entityList && !entityList.length);
        }
      }
    }
  };

  const fetchSocialTopics = (isdelete, length) => {
    setIsSocialTopicsLoading(true);
    const perPage = isdelete ? length - 1 : 10;
    const page = isdelete ? 1 : limit;
    httpGet(
      `${unifiedEnvConfig.FETCH_ALL_TOPICS}?client_id=${selectedClient.id}&perPage=${perPage}&page=${page}`
    )
      .then((response) => {
        if (response) {
          setSocialTopicList(response.data.data);
        }
      })
      .catch((e) => e)
      .finally(() => setIsSocialTopicsLoading(false));
  };

  const handleEntityChange = (e, ent, tab) => {
    if (isWidgetPage) {
      return null;
    }
    dispatch(
      setSelectedEntity(
        entityList &&
          entityList.filter((entity) => {
            if (entity.id === ent.id) {
              return entity;
            }
            return null;
          })[0]
      )
    );
    history.push(`${FEED}/${ent.id}/${tab}`, ent);
  };

  const isSocial = currentSelectedTopicTab == VERTICALS.V_SOCIAL;

  if (!currentSelectedTopicTab) {
    return null;
  }

  const showMoreButton = () => {
    if (socialTopicList && socialTopicList.length < 10) {
      return false;
    }
    if (isSocial) {
      return !hideShowMore;
    }
    return false;
  };

  function handleMoreClick() {
    setLimit(limit + 1);
  }

  const showLoader = () => {
    return isSocial ? isSocialTopicsLoading : isLoading;
  };

  const renderTopicList = () => {
    if (showLoader()) {
      return <Loader />;
    } else if (showTopicList) {
      return (
        <>
          <table className="table customTableTwo">
            <thead>
              <tr className="topicRow">
                <th className="thTopicName">Topic Name</th>
                {isWidgetPage && <th>Select</th>}
                {isSocial && !isWidgetPage && (
                  <>
                    <th className="thDate">Date</th>
                    <th className="thAction"></th>
                  </>
                )}
              </tr>
            </thead>
            <tbody>
              {isSocial && (
                <TopicsList
                  isWidgetPage={isWidgetPage}
                  entityList={socialEntityList}
                  selectedEntity={selectedEntity}
                  handleEntityChange={handleEntityChange}
                  setEditData={setEditData}
                  key={1}
                  isSocial={isSocial}
                  history={history}
                  setSelectedTab={setSelectedTab}
                  selectedTopicList={selectedTopicList}
                  setSelectedTopicList={setSelectedTopicList}
                  fetchSocialTopics={fetchSocialTopics}
                />
              )}
              {!isSocial && (
                <TopicsList
                  key={2}
                  isWidgetPage={isWidgetPage}
                  entityList={entityList}
                  selectedEntity={selectedEntity}
                  handleEntityChange={handleEntityChange}
                  isOnline={currentSelectedTopicTab == VERTICALS.V_ONLINE}
                  isPrint={currentSelectedTopicTab == VERTICALS.V_PRINT}
                  history={history}
                  setSelectedTab={setSelectedTab}
                  selectedTopicList={selectedTopicList}
                  setSelectedTopicList={setSelectedTopicList}
                />
              )}
            </tbody>
          </table>
          {/* {showMoreButton() && (
            <div className="loadMoreBtnWrap text-center">
              <Button
                className="btn redBtn loadMoreBtn"
                disabled={hideShowMore}
                label="Show All"
                onClick={() => handleMoreClick()}
              ></Button>
            </div>
          )} */}
        </>
      );
    } else {
      return (
        <div className="noFilterDataWrap">
          <NoFeedIcon />
          <h6>No Topics Found</h6>
          <p>Please create a topic to view feed</p>
        </div>
      );
    }
  };
  const showTopicList = !noTopicsFound && !showLoader();

  return (
    <>
      {!isWidgetPage && (
        <div className="dashboardHeader">
          <div className="dashboardHeaderTop d-flex">
            <div className="dhLeft d-flex">
              <div className="dhLeftWrap">
                {!showAddTopic && <h1>Topics</h1>}
                {/* {showAddTopic && <h1>Add Topic</h1>} */}
              </div>
            </div>
            {/* TODO: To be removed, if not needed on topic listing page.
            <div className="dhRight d-flex">
              <a
                type="submit"
                className="btn redBtn"
                onClick={() => setShowAddTopic(!showAddTopic)}
              >
                {!showAddTopic ? "+ Add Topic" : "View All Topics"}
              </a>
              <UserDropdown />
            </div> */}
          </div>
          <div className="dashboardHeaderBottom d-flex">
            <div className="dhLeft">
              {!showAddTopic && !isWidgetPage ? (
                <ul className="horizontalTabs">
                  {VERTICAL_OPTIONS.map((options) => {
                    if (!options) return null;
                    const { value, label } = options;
                    return (
                      <li
                        className={
                          currentSelectedTopicTab == value ? "active" : ""
                        }
                        key={value}
                        onClick={() => {
                          history.push(`${TOPICS}/${value}`);
                        }}
                      >
                        {label}
                      </li>
                    );
                  })}
                </ul>
              ) : null}
            </div>
          </div>
        </div>
      )}
      <div
        className={`mainContainer ${
          isWidgetPage
            ? "widgetContainer"
            : showAddTopic
            ? "addTopicContainer"
            : "topicListContainer"
        }`}
      >
        {editData ? (
          <AddTopic
            setShowAddTopic={setShowAddTopic}
            setEditData={setEditData}
            history={history}
            data={editData}
            isEdit
          />
        ) : (
          renderTopicList()
        )}
      </div>
    </>
  );
}
